import { useEffect, useState } from 'react';
import './css/Acp.css';
import axios from 'axios';
import { API_BASE_URL } from '../config/ApiConfig';
import LoadingModal from './components/modals/LoadingModal';
import Pagination10 from './components/Pagination10';
import DefaultModal from './components/modals/DefaultModal';
import PessoaDependenteModal from './components/modalServices/PessoaDependenteModal';
import usePagination10 from './components/hooks/usePagination10';
import { useNavigate, useLocation } from 'react-router-dom';
import { formatDateView } from './utils/dateUtils';
import PageCard from './components/PageCard';

function PessoaDependentes() {
  const [pessoa, setPessoa] = useState({
    cnpjAssociacao: '',
    cpf: '',
    id: '',
    nome: '',
    dataNasc: '',
    sexo: '',
    estadoCivil: '',
    nomePai: '',
    nomeMae: '',
    rgNum: '',
    rgDataEmissao: '',
    rgUf: '',
    rgEmissor: '',
    nacionalidade: '',
    profissao: '',
    cpfConjuge: '',
    nomeConjuge: '',
    logrNome: '',
    logrNum: '',
    logrCompl: '',
    logrBairro: '',
    logrCep: '',
    logrCidade: '',
    logrUf: '',
  });
  const [dependentesOriginais, setDependentesOriginais] = useState([]);
  const [atualizar, setAtualizar] = useState(0);
  const token = localStorage.getItem('token');
  const cnpj = localStorage.getItem('cnpj');
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const [modalData, setModalData] = useState({
    show: false,
    type: '',
    message: '',
  });
  const [filtro, setFiltro] = useState('');
  const [showDependenteModal, setShowDependenteModal] = useState(false);
  const [dependenteParaEditar, setDependenteParaEditar] = useState(null);
  const [dependenteSelecionado, setDependenteSelecionado] = useState(null);

  const showDefaultModal = (type, message) => {
    setModalData({ show: true, type, message });
  };
  const closeDefaultModal = () => {
    setModalData(prev => ({ ...prev, show: false }));
  };

  // Effect para carregar pessoa do estado da navegação
  useEffect(() => {
    if (!token) {
      navigate('/');
      return;
    }
    console.log('Location state:', location.state);
    if (location.state && location.state.pessoa) {
      setPessoa(location.state.pessoa);
      console.log('Pessoa carregada do estado:', location.state.pessoa);
    } else {
      console.log('Nenhuma pessoa encontrada no estado da navegação');
    }
  }, [token, navigate, location.state]);

  // Effect para carregar dependentes quando pessoa está disponível
  useEffect(() => {
    if (!pessoa.id) return; // Só executa quando pessoa.id estiver disponível

    setLoading(true);
    axios
      .get(`${API_BASE_URL.PESSOA_DEPENDENTE}/all`, {
        params: { cnpjAssociacao: cnpj, idPessoa: pessoa.id },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(result => {
        setDependentesOriginais(result.data);
        console.log('Dependentes carregados para pessoa:', pessoa.id);
      })
      .catch(error => console.error('Erro ao carregar dependentes:', error))
      .finally(() => setLoading(false));
  }, [pessoa.id, cnpj, token, atualizar]); // Filtro por nome ou CPF do dependente
  const dependentesFiltrados = dependentesOriginais.filter(d => {
    if (!filtro) return true;
    const filtroUpper = filtro.toUpperCase();
    return (
      (d.nome && d.nome.toUpperCase().includes(filtroUpper)) ||
      (d.cpf && d.cpf.includes(filtro))
    );
  });
  const totalItems = dependentesFiltrados.length;
  const { setPagination } = usePagination10(totalItems);
  const selectedDependentes = dependentesFiltrados.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  function handleDelete(d) {
    axios
      .delete(`${API_BASE_URL.PESSOA_DEPENDENTE}/delete`, {
        params: {
          cnpjEscola: d.cnpjEscola,
          idPessoa: d.idPessoa,
          cpf: d.cpf,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        setAtualizar(prev => prev + 1);
        showDefaultModal('success', 'O registro foi excluído com sucesso!');
      })
      .catch(error => {
        console.error('Erro ao excluir registro:', error);
        showDefaultModal('error', 'Erro ao excluir o registro.');
      });
  }

  const handleDependenteModalClose = () => {
    setShowDependenteModal(false);
    setDependenteParaEditar(null);
  };

  const handleDependenteSaveSuccess = (novoDependente, isEditing) => {
    if (isEditing) {
      // Atualizar lista completa ao editar
      setAtualizar(prev => prev + 1);
    } else {
      // Adicionar novo dependente ao final da lista
      setDependentesOriginais(prev => [...prev, novoDependente]);
    }

    showDefaultModal(
      'success',
      `Dependente ${isEditing ? 'atualizado' : 'cadastrado'} com sucesso!`
    );
  };

  return (
    <PageCard
      title="Dependentes"
      icon="bi-diagram-2"
      scrollable={false}
      onClose={() => navigate('/pessoas')}
      footer={totalItems > 0 ? <Pagination10 {...setPagination} /> : null}
    >
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>

        {pessoa.nome && (
          <p className="text-muted mb-1 small">
            <strong>Associado(a):</strong> {pessoa.nome} - CPF: {pessoa.cpf}
          </p>
        )}

        <div className="d-flex flex-wrap gap-1 mb-2 p-2 bg-light rounded border align-items-center">
          <button
            className="btn btn-success btn-sm d-inline-flex align-items-center"
            onClick={() => {
              setDependenteParaEditar(null);
              setShowDependenteModal(true);
            }}
          >
            <i className="bi bi-plus-lg me-1" />
            Novo
          </button>
          <button
            className="btn btn-primary btn-sm d-inline-flex align-items-center"
            onClick={() => {
              if (dependenteSelecionado) {
                setDependenteParaEditar(dependenteSelecionado);
                setShowDependenteModal(true);
              }
            }}
            disabled={!dependenteSelecionado}
          >
            <i className="bi bi-pencil me-1" />
            Editar
          </button>
          <div className="vr mx-1" />
          <button
            className="btn btn-danger btn-sm d-inline-flex align-items-center"
            onClick={() => {
              if (dependenteSelecionado) {
                handleDelete(dependenteSelecionado);
              }
            }}
            disabled={!dependenteSelecionado}
          >
            <i className="bi bi-trash me-1" />
            Excluir
          </button>

          <div className="ms-auto d-flex align-items-center">
            <div className="input-group" style={{ maxWidth: 300, height: 31 }}>
              <span className="input-group-text bg-white border-end-0 px-2" style={{ height: 31 }}>
                <i className="bi bi-search text-muted" style={{ fontSize: 13 }} />
              </span>
              <input
                type="text"
                className="form-control form-control-sm border-start-0"
                style={{ textTransform: 'uppercase', height: 31, fontSize: 13 }}
                placeholder="Pesquisar por nome ou CPF..."
                value={filtro}
                onChange={e => setFiltro(e.target.value.toUpperCase())}
              />
              {filtro && (
                <button
                  className="btn btn-outline-secondary btn-sm border-start-0 d-flex align-items-center px-2"
                  style={{ height: 31 }}
                  onClick={() => setFiltro('')}
                  title="Limpar pesquisa"
                  tabIndex={-1}
                >
                  <i className="bi bi-x-lg" style={{ fontSize: 11 }} />
                </button>
              )}
            </div>
          </div>
        </div>

        <LoadingModal loading={isLoading} />

        <div
          className="table-responsive-sm shadow-sm mb-0 small"
          style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}
        >
              <table className="table table-hover table-striped table-sm">
                <thead className="table-secondary sticky-top bg-light">
                  <tr>
                    <th className="px-2 align-middle" style={{ width: '15%' }}>
                      CPF
                    </th>
                    <th className="px-2 align-middle">Nome</th>
                    <th className="px-2 align-middle" style={{ width: '20%' }}>
                      Data de Nascimento
                    </th>
                    <th className="px-2 align-middle">Grau de Parentesco</th>
                  </tr>
                </thead>
                <tbody>
                  {!isLoading &&
                    selectedDependentes.map(d => (
                      <tr
                        key={`${d.cnpjEscola}-${d.idPessoa}-${d.cpf}`}
                        className={`${
                          dependenteSelecionado?.cpf === d.cpf
                            ? 'table-primary'
                            : ''
                        }`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          if (dependenteSelecionado?.cpf === d.cpf) {
                            setDependenteSelecionado(null); // Deselecionar se já estiver selecionado
                          } else {
                            setDependenteSelecionado(d); // Selecionar novo dependente
                          }
                        }}
                      >
                        <td className="px-2">{d.cpf}</td>
                        <td className="px-2">{d.nome}</td>
                        <td className="px-2">{formatDateView(d.dataNasc)}</td>
                        <td className="px-2">{d.grauParentesco}</td>
                      </tr>
                    ))}
                  {!isLoading && dependentesFiltrados.length === 0 && (
                    <tr>
                      <td colSpan="4" className="text-center">
                        Nenhum dependente encontrado.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
      </div>

      <DefaultModal
        show={modalData.show}
        type={modalData.type}
        onClose={closeDefaultModal}
        message={modalData.message}
      />
      <PessoaDependenteModal
        show={showDependenteModal}
        onClose={handleDependenteModalClose}
        onSaveSuccess={handleDependenteSaveSuccess}
        dependente={dependenteParaEditar}
        pessoa={pessoa}
      />
    </PageCard>
  );
}

export default PessoaDependentes;
